import { connect } from 'react-redux'
import actions from 'actions/index'
import selectors from 'selectors/index'
const {
  getContactReciprocalRoles,
  getCurrentContactReciprocalRole,
  getCurrentContactRelationship,
  getCurrentContacts,
  getCurrentFinancialAccountContacts,
  getCurrentInvestmentPlan,
  getFinancialAccountRelatedData,
  getFirstTeamMember,
  getMyUploadedDocs,
  getNextTeamMembers,
  getNavLinks,
  getOverview,
  getPrimaryPortfolio,
  getSharedWithMeDocs,
  isClientUser,
  isProspectUser,
} = selectors

const connectApp = (Component) => {
  const mapStateToProps = (state, ownProps) => (
    {
      location: state.location,
      ...state.loading,
      ...state.jointOwners,
      ...state.prospect,
      ...state.contacts,
      ...state.financialAccounts,
      ...state.sidebar,
      ...state.system,
      ...state.user,
      ...state.teamMembers,
      ...state.documents,
      ...state.investmentPlans,
      ...state.mobileNav,
      ...state.blackDiamondError,
      ...state.boxError,
      ...state.isInitialLoad,
      ...state.loadingPortfolio,
      ...state.loadingPortfolioClassAllocations,
      ...state.loadingPortfolioAccounts,
      ...state.loadingPortfolioHoldings,
      ...state.loadingDocuments,
      ...state.notifications,
      ...state.contactFinancialAccountRoles,
      ...state.reciprocalRoles,
      ...state.contactRelationships,
      ...state.contactTypes,
      currentInvestmentPlan: getCurrentInvestmentPlan(state),
      overview: getOverview(state),
      currentAccount: getFinancialAccountRelatedData(state),
      primaryPortfolio: getPrimaryPortfolio(state),
      myUploadedDocs: getMyUploadedDocs(state),
      sharedWithMeDocs: getSharedWithMeDocs(state),
      firstTeamMember: getFirstTeamMember(state),
      nextTeamMembers: getNextTeamMembers(state),
      prospectExperience: isProspectUser(state),
      navLinks: getNavLinks(isProspectUser(state)),
      clientExperience: isClientUser(state),
      currentFinancialAccountContacts: getCurrentFinancialAccountContacts(state),
      contactReciprocalRoles: getContactReciprocalRoles(state),
      currentContactRelationship: getCurrentContactRelationship(state),
      currentContactReciprocalRole: getCurrentContactReciprocalRole(state),
      currentContacts: getCurrentContacts(state)
    }
  )

  const mapDispatchToProps = {
    ...actions
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Component)
}

export default connectApp



// WEBPACK FOOTER //
// ./src/connectApp.jsx